module.exports = __webpack_public_path__ + "img/products_tab_icon1.9b0c0d85.png";